import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import AddImageIcon from '@assets/icons/addImageIcon';
import { Context } from "routes/private/Editor/Context";
import ToolTip from '@components/Tooltip';

const ImageTool: React.FC<IProps> = (props) => {
  let context = useContext(Context);
  
  const handleOpenNewImage = () => {  
    const picker = (context.editorStatus.currentPicker==="AddNewImage")?undefined:"AddNewImage";
    context.onShowPicker(picker);
  }
  
  return (
    <S.Root>
      <S.IconContainer
        onClick={handleOpenNewImage}
      >
        <ToolTip
          tip="Add Image"
          boxStyle={{
            top: `0px`,
            left: `30px`,
            right: `auto`,
            width: `140px`,
            justifyContent: `start`
          }}        
        >
          <AddImageIcon
            fillColor={["AddNewImage", "ReplaceImage"].includes(context.editorStatus.currentPicker ?? '') ? C.WHITE : undefined}
          />
        </ToolTip>
      </S.IconContainer>
    </S.Root>
  );
}

export default ImageTool;